<style>
    .ly-navigation{
        position: relative;
        color: #fff;
        overflow: hidden;
    }
    .ly-logo {
        text-align: center;
        height: 50px;
        
    }
    .ly-logo-img {
            margin-top: 5px;
            height: 40px;
        }
    .ly-menu {
        position: absolute;
        top:50px;
        right: -20px;
        bottom: 0;
        left: 0;
        overflow-y: auto;
        
    }
    .ly-menu-layout {
            width: 130px;
        }
</style>
<template>
    <div class="ly-navigation">
        <!-- <div class="ly-logo">
            <img v-if="other_domain" src="../../../assets/img/logo2.png" alt="" class="ly-logo-img">
            <img v-else src="../../../assets/img/logo.png" alt="" class="ly-logo-img">
        </div> -->
        <div class="ly-menu" v-if="currRoute">
            <el-menu class="ly-menu-layout" @open="handleOpen" @close="handleClose" 
                :default-openeds="defOpen"
                :default-active="currRoute.name"
                v-if="currRoute.name && currRoute.name.length > 0">
                <!-- 2018-01-04这里25批需要隐藏“基础资料”，暂时写死，后续加权限的时候就要取消 -->
                <!-- 2018-02-11 修改没有财务角色了,duty名字要变，使用role来判断 -->
                <!-- <el-submenu v-for="(el, i) in nav" :key="i" :index="el.name" 
                    v-if="el.name != '基础资料' || (el.name == '基础资料' && (userInfo.role == 'business'))"> -->
                <!-- 2018-05-04修改，现在有权限了，取消代码中对“基础资料的判断” -->
                 <el-submenu v-for="(el, i) in nav" :key="i" :index="el.name" >
                    <template slot='title'>
                        <i :class="el.icon"></i>&nbsp;&nbsp;{{el.name}}
                    </template>
                    <template v-for="(item,i) in el.children">
                        <el-menu-item :key="'sub'+i" :index="item.name" @click="menuItemClick(item)">{{item.name}}</el-menu-item>
                    </template>
                </el-submenu>
            </el-menu>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    export default {
        name: 'LyNavigation',
        props: {
            /**
             * 路由配置数据，数据格式示例:
                [{
                    "id": 1,
                    "icon": "fa fa-magnet",
                    "name": "销售业务",
                    "children": [{
                        "id": 1,
                        "name": "销售开单" ,
                        "type": "bill",
                        "path": "order",
                        "page": [{
                            "label": "list",
                            "status": true,
                        }]
                    }]
                }]
             */
            nav: {
                type: Array
            }
        },
        data () {
            return {
                defaultActive: ''
            }
        },
        watch: {
            /**
             * 暂时使用nav.children里面的type与route.name判断，
             * 此为不妥，因为路由名字命名有点混乱，暂为解决三包查询完毕跳转菜单高亮做此操作
             */
            '$route.name' (v) {
                // let rsRoute = v.split('/')[2]
                this.nav.forEach((item) => {
                    item.children.forEach((e) => {
                        if (e.type === v) {
                            this.$emit('itemclick', e)
                        }
                    })
                })
            }
        },
        computed: {
            ...mapGetters([
                'userInfo'     
            ]),
            ...mapGetters('route', [
                'currRoute'
            ]),
            // 设置默认打开的菜单
            defOpen () {
                if (this.nav && this.nav.length > 0) {
                    return [this.nav[0]['name']]
                } else {
                    return []
                }
            }
        },
        methods: {
            handleOpen (key, keyPath) {
                console.log(key, keyPath);
            },
            handleClose (key, keyPath) {
                console.log(key, keyPath);
            },
            /**
             * 菜单项点击得监听
             * @param  {[Object]} item [菜单路由对象]
             */
            menuItemClick (item) {
                this.$emit('itemclick', item)
            },
            /**
             * 设置默认的选中项
             * @param {[type]} active [description]
             */
            setDefaultActive (active) {
                this.active = active
            }
        }
    }
</script>